(ns shared.core.amelia-light.components.toggle-group
  (:require [shared.core.reactive :as re]
            ["@up/base-ui/components/ui/toggle-group" :refer [ToggleGroup ToggleGroupItem]]))

(defn up-toggle-group-item [args & contents]
  (into [:> ToggleGroupItem args]
        contents))

(defn up-toggle-group [{:keys [items form-path form-name selected] :as args}]
  (let [selected (or selected (when (and form-path form-name) @(re/subscribe [:form/val- form-path form-name])))]
    (into [:> ToggleGroup (cond-> (dissoc args :items :form-path :form-name :selected)
                            selected (assoc :value selected))]
          (mapv (fn [item]
                  (conj [up-toggle-group-item (dissoc item :content)]
                        (:content item)))
                items))))